import createAction from 'utils/redux-helpers/createAction';

const handler = (state, { id }) => state.set('activeAddress', id);

export const selectAddress = createAction({
  action: ['selectAddress', 'id'],
  handler,
});
